/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

/* eslint-disable */

/* global jQuery */

import gsap from 'gsap';

import preloader from '../preloader';
import animation from '../animation';

( function() {
	var container, menu, links, i, len;

	container = document.getElementById( 'site-navigation' );
	if ( ! container ) {
		return;
	}

	menu = container.getElementsByTagName( 'ul' )[0];

	// Return if menu is empty.
	if ( 'undefined' === typeof menu ) {
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	// Get all the link elements within the menu.
	links = menu.getElementsByTagName( 'a' );

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'has-focus' ) ) {
					self.className = self.className.replace( ' has-focus', '' );
				} else {
					self.className += ' has-focus';
				}
			}

			self = self.parentElement;
		}
	}

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	( function( container ) {

		const parentLinks = jQuery( container ).find( '.menu-item-has-children > a, .page_item_has_children > a' );
		const animationDuration = 0.5;

		const touchEndFn = function( e ) {

			var menuItem = this.parentNode;

			if ( ! menuItem.classList.contains( 'focus' ) ) {

				e.preventDefault();

				for ( let i = 0; i < menuItem.parentNode.children.length; ++i ) {
					if ( menuItem === menuItem.parentNode.children[i] ) {
						continue;
					}
					menuItem.parentNode.children[i].classList.remove( 'focus' );
				}

				menuItem.classList.add( 'focus' );
			}

			else {
				menuItem.classList.remove( 'focus' );
			}

			if ( ! menuItem.classList.contains( 'expanded' ) ) {

				gsap.to(
					jQuery( menuItem ).children( '.sub-menu' ),
					{
						duration: animationDuration,
						height: 'auto',
						ease: 'back.easeOut'
					}
				);

				menuItem.classList.add( 'expanded' );
			}

			else {

				gsap.to(
					jQuery( menuItem ).children( '.sub-menu' ),
					{
						duration: animationDuration,
						height: 0
					}
				);

				menuItem.classList.remove( 'expanded' );
			}
		};

		// HEY! Listen
		parentLinks.on( 'vclick', touchEndFn );

	}( container ) );

	jQuery( window ).on(
		preloader.finishEvent,
		() => animation.resolve( jQuery( '.header' ) )
	);

} )();



// WEBPACK FOOTER //
// ./src/js/inc/vendor/navigation.js